import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6998976b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "fs-6 fw-bold" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = { class: "card-body fs-5" }
const _hoisted_7 = { class: "fw-bold uppercase" }
const _hoisted_8 = { class: "mb-1" }

import SystemService from "@/projects/tenant/modules/system/services/SystemService";
import { ref, onMounted } from "vue";
import { TenantTypes } from "@/core/types/TenantTypes";

export default /*#__PURE__*/_defineComponent({
  __name: 'DealingOnline',
  setup(__props) {

const isLoading = ref(false);
const data = ref<any>([]);
const tenantId = ref<any>(null);

var siteColors = {
  au: "#7a9e7a",
  bvi: "#fa6b6c",
  sea: "#349beb",
  mn: "#b497b4",
  jp: "#f6c23e",
};

const getSiteColor = (site: any) => {
  return siteColors[TenantTypes[site]] || "#000000"; // default color if site not found
};

const fecthData = async () => {
  isLoading.value = true;
  try {
    const res = await SystemService.queryOnlineAdmin();
    data.value = res;
  } catch (e) {
    console.log(e);
  }
  isLoading.value = false;
};

onMounted(() => {
  tenantId.value = localStorage.getItem("tenant");
  fecthData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("fields.adminOnline")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          type: "success",
          onClick: fecthData,
          loading: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.refresh")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "mb-3"
          }, [
            (_ctx.$can('SuperAdmin') || tenantId.value == item.tenantId)
              ? (_openBlock(), _createBlock(_component_el_card, {
                  key: 0,
                  style: _normalizeStyle({ borderTop: `2px solid ${getSiteColor(item.tenantId)}` })
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(TenantTypes)[item.tenantId]), 1)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.users, (admin, i) => {
                      return (_openBlock(), _createElementBlock("div", { key: i }, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(admin.email), 1)
                      ]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["style"]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])), [
      [_directive_loading, isLoading.value]
    ])
  ]))
}
}

})